import React from 'react';
import {useTranslation} from 'react-i18next';
import {AgentInfoExtra} from '../../agent.type';
import {ReactComponent as PersonIcon} from '@/assets/icons/invitation/person.svg';
import {AGENT_LEVEL_CONFIG} from '@/pages/agent/constants';

const rewardCardBg = require('@/pages/agent/assets/reward-card-bg.webp');

interface AgentLevelCardsProps {
  agentInfoExtra?: AgentInfoExtra;
}

const AgentLevelCards: React.FC<AgentLevelCardsProps> = ({agentInfoExtra}) => {
  const {t} = useTranslation();

  // 获取当前等级配置，使用 agentInfoExtra 的等级，默认为等级1
  const currentLevel = Math.max(
    1,
    Math.min(4, agentInfoExtra?.agentLevel || 1),
  );
  const levelConfig =
    AGENT_LEVEL_CONFIG[currentLevel as keyof typeof AGENT_LEVEL_CONFIG];

  return (
    <div className="flex flex-row gap-3 px-3">
      {/* Rebate Level Card */}
      <div className="bg-white h-[4.4375rem] overflow-hidden relative rounded-lg shrink-0 w-[10.75rem]">
        {/* Background */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{backgroundImage: `url(${rewardCardBg})`}}
        />

        {/* Content */}
        <div className="absolute flex flex-col gap-2 items-center justify-center size-full px-3">
          <div className="flex flex-row items-center gap-1">
            <p className="font-bold text-sm text-t1">
              {t('agent.level-cards.rebate-level')}
            </p>
          </div>
          <div className="flex items-center justify-center">
            <div className="w-[3.1875rem] h-[1.25rem] relative">
              <img
                src={levelConfig.badgeImage}
                alt={`Level ${currentLevel}`}
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Team Size Card */}
      <div className="bg-white h-[4.4375rem] overflow-hidden relative rounded-lg shrink-0 w-[10.75rem]">
        {/* Background */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{backgroundImage: `url(${rewardCardBg})`}}
        />

        {/* Content */}
        <div className="absolute flex flex-col gap-2 items-center justify-center size-full px-3">
          <div className="flex flex-col items-center">
            <p className="font-bold text-sm text-t1">
              {t('agent.level-cards.team-size')}
            </p>
          </div>
          <div className="flex flex-row items-center gap-1">
            <PersonIcon className="size-4" />
            <p className="text-lg font-bold text-[#F15802]">
              {agentInfoExtra?.agentTeamUserCount || 0}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentLevelCards;
